import { render, staticRenderFns } from "./Tournament2024.vue?vue&type=template&id=fc03dff0&scoped=true"
import script from "./Tournament2024.vue?vue&type=script&lang=js"
export * from "./Tournament2024.vue?vue&type=script&lang=js"
import style0 from "./Tournament2024.vue?vue&type=style&index=0&id=fc03dff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc03dff0",
  null
  
)

export default component.exports